const formRestoreEquipment = {
  text: 'Deseja realmente restaurar o equipamento',
  text2: 'Todos os Serviços e Ações relacionadas a esse equipamento serão restaurados.',
  title: 'RESTAURAR EQUIPAMENTO',
  buttonText: 'RESTAURAR EQUIPAMENTO DELETADO',
};

export default formRestoreEquipment;
